module.exports = __webpack_public_path__ + "img/logo_rectangle_white.a062198e.png";